import ApiService from './api.service'

const ExportFieldMappingService = {
  index () {
    return ApiService.get('api/v1/admin/export-field-mappings')
  },
  changeOrder (data) {
    return ApiService.putWithoutLoading('api/v1/admin/export-field-mappings/change-order', data)
  },
  store (data) {
    return ApiService.postWithoutLoading('api/v1/admin/export-field-mappings', data)
  },
  update (uuid, data) {
    return ApiService.putWithoutLoading(`api/v1/admin/export-field-mappings/${uuid}`, data)
  },
  destroy (uuid) {
    return ApiService.deleteWithoutLoading(`api/v1/admin/export-field-mappings/${uuid}`)
  }
}

export default ExportFieldMappingService
